<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li *ngIf="getUserCurrent().company.uniqid === 'admin'" class="breadcrumb-item">
            <a routerLink="/{{getUserCurrent().company.uniqid}}/company">List companies</a>
          </li>
          <li class="breadcrumb-item">
            Manage invoice recipients
          </li>
        </ol>
      </nav>
    </nav>
  </div>
  <div class="layout-main">
    <div class="container-fluid">
      <div class="pb-2 mb-3 border-bottom">
        <h3>
          <b>Manage invoice recipients {{ companyName }}</b>
          <button (click)="showAddMckayEntityDialog()" *roles="['ROLE_MCKAY']"
                  class="btn btn-outline-info float-right ml-2">
            <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>Add mckay Entities
          </button>
          <button (click)="exportToXLSX()" class="btn btn-outline-info float-right">
            <i aria-hidden="true" class="fa fa-file-excel-o pr-2"></i>Export to XLSX
          </button>
        </h3>
      </div>
      <div *ngIf="!readOnly" class="col-12 alert alert-primary">
        <strong>Please assign a list of selected finance-role users by mckay entity.
          You must assign at least one user to each list.
          Only activated users (who logged in once) with the finance role can be selected.</strong><br>
      </div>
      <div *ngIf="readOnly" class="col-12 alert alert-primary">
        <strong>If you want to make a change to this page, please contact your admin users: {{ admins }} must
          assign at least one user to each list.</strong><br>
      </div>
      <div *ngIf="unusedContacts.length > 0" class="alert alert-warning" role="alert">
        {{ unusedContacts.length }} contacts are not used in any list
        <div class="tooltip-wrapper">
          <i aria-hidden="true" class="fa fa-info-circle tooltip-target"></i>
          <div [innerHTML]="getUnusedContactsTooltip()" class="tooltip-content">
          </div>
        </div>
      </div>
      <div *ngIf="success" class="alert alert-success alert-dismissible fade show">
        Users updated successfully
        <button (click)="success = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show">
        {{ errorMessage }}
        <button (click)="errorMessage = ''" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row dynamic-width">
        <div *ngIf="mbuDisplayed" class="col-md-3 mb-3 dynamic-fieldset">
          <fieldset class="fieldset-border fieldset-scroll">
            <legend style="font-size: 13px; margin-bottom: 0;">{{ mbuFieldsetTitle }}</legend>
            <div class="font-weight-bold">{{ mbuContracts }}</div>
            <div>
              Contacts selected: {{ mbuRecipientsList.length }}/{{ recipientsList.length }}
              <button (click)="selectAll(mbuRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-primary ml-2">Select All
              </button>
              <button (click)="deselectAll(mbuRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-secondary ml-2">Deselect All
              </button>
            </div>
            <div (click)="!readOnly && toggleSelection(recipient, mbuRecipientsList)"
                 *ngFor="let recipient of recipientsList"
                 [class.read-only]="readOnly"
                 [ngClass]="{
                   'dark-blue': isRecipientInList(recipient, mbuRecipientsList),
                   'light-blue': !isRecipientInList(recipient, mbuRecipientsList),
                   'selected': recipient.selected
                 }">
              <span class="tag">{{ recipient.name }} &lt;{{ recipient.email }}&gt;</span>
            </div>
          </fieldset>
        </div>
        <div *ngIf="qduDisplayed" class="col-md-3 mb-3 dynamic-fieldset">
          <fieldset class="fieldset-border fieldset-scroll">
            <legend style="font-size: 13px; margin-bottom: 0;">{{ qduFieldsetTitle }}</legend>
            <div class="font-weight-bold">{{ qduContracts }}</div>
            <div>
              Contacts selected: {{ qduRecipientsList.length }}/{{ recipientsList.length }}
              <button (click)="selectAll(qduRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-primary ml-2">Select All
              </button>
              <button (click)="deselectAll(qduRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-secondary ml-2">Deselect All
              </button>
            </div>
            <div (click)="!readOnly && toggleSelection(recipient, qduRecipientsList)"
                 *ngFor="let recipient of recipientsList"
                 [class.read-only]="readOnly"
                 [ngClass]="{
                   'dark-blue': isRecipientInList(recipient, qduRecipientsList),
                   'light-blue': !isRecipientInList(recipient, qduRecipientsList),
                   'selected': recipient.selected
                 }">
              <span class="tag">{{ recipient.name }} &lt;{{ recipient.email }}&gt;</span>
            </div>
          </fieldset>
        </div>
        <div *ngIf="mbiDisplayed" class="col-md-3 mb-3 dynamic-fieldset">
          <fieldset class="fieldset-border fieldset-scroll">
            <legend style="font-size: 13px; margin-bottom: 0;">{{ mbiFieldsetTitle }}</legend>
            <div class="font-weight-bold">{{ mbiContracts }}</div>
            <div>
              Contacts selected: {{ mbiRecipientsList.length }}/{{ recipientsList.length }}
              <button (click)="selectAll(mbiRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-primary ml-2">Select All
              </button>
              <button (click)="deselectAll(mbiRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-secondary ml-2">Deselect All
              </button>
            </div>
            <div (click)="!readOnly && toggleSelection(recipient, mbiRecipientsList)"
                 *ngFor="let recipient of recipientsList"
                 [class.read-only]="readOnly"
                 [ngClass]="{
                   'dark-blue': isRecipientInList(recipient, mbiRecipientsList),
                   'light-blue': !isRecipientInList(recipient, mbiRecipientsList),
                   'selected': recipient.selected
                 }">
              <span class="tag">{{ recipient.name }} &lt;{{ recipient.email }}&gt;</span>
            </div>
          </fieldset>
        </div>
        <div *ngIf="jsdDisplayed" class="col-md-3 mb-3 dynamic-fieldset">
          <fieldset class="fieldset-border fieldset-scroll">
            <legend style="font-size: 13px; margin-bottom: 0;">{{ jsdFieldsetTitle }}</legend>
            <div class="font-weight-bold">{{ jsdContracts }}</div>
            <div>
              Contacts selected: {{ jsdRecipientsList.length }}/{{ recipientsList.length }}
              <button (click)="selectAll(jsdRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-primary ml-2">Select All
              </button>
              <button (click)="deselectAll(jsdRecipientsList)" [disabled]="readOnly"
                      class="btn btn-sm btn-outline-secondary ml-2">Deselect All
              </button>
            </div>
            <div (click)="!readOnly && toggleSelection(recipient, jsdRecipientsList)"
                 *ngFor="let recipient of recipientsList"
                 [class.read-only]="readOnly"
                 [ngClass]="{
                   'dark-blue': isRecipientInList(recipient, jsdRecipientsList),
                   'light-blue': !isRecipientInList(recipient, jsdRecipientsList),
                   'selected': recipient.selected
                 }">
              <span class="tag">{{ recipient.name }} &lt;{{ recipient.email }}&gt;</span>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="buttons-container">
        <button (click)="save()" [disabled]="saveDisabled || readOnly" class="btn btn-outline-success mr-1">
          <i aria-hidden="true" class="fa fa-check-circle pr-2"></i>Save
        </button>
        <button (click)="cancel()" [disabled]="readOnly" class="btn btn-outline-primary">
          <i aria-hidden="true" class="fa fa-close pr-2"></i>Cancel
        </button>
      </div>
    </div>
  </div>
</div>
<p-dialog [(visible)]="addMckayEntityDialogDisplay" [closable]="false" [modal]="true">
  <p-header>
    Add a Mckay Entity
  </p-header>
  <div>
    <form (ngSubmit)="onSubmitAddMckayEntity()" *ngIf="addMckayEntityForm" [formGroup]="addMckayEntityForm">
      <div class="form-group">
        <label>Select Mckay Entities</label>
        <div class="pl-2">
          <div *ngFor="let entity of availableMckayEntitiesAsArray">
            <p-checkbox
              [disabled]="isEntitySelected(entity.uuid) || hasContracts(entity.uuid)"
              binary="true"
              formControlName="{{ entity.uuid }}">
            </p-checkbox>
            <label>{{ entity.name }}</label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end buttons-margin-left mt-3">
        <button (click)="hideAddMckayEntityDialog()" class="btn btn-outline-primary" type="button">
          <i aria-hidden="true" class="fa fa-close pr-2"></i> Cancel
        </button>
        <button [disabled]="addMckayEntityForm.invalid" class="btn btn-outline-primary ml-3" type="submit">
          <i aria-hidden="true" class="fa fa-plus pr-2"></i> Add
        </button>
      </div>
    </form>
  </div>
</p-dialog>
